import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgGridQueryParams, BaseFilterDto, BaseList, BaseResponse, ProviderGamesDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { searchAggregatorProviderGames } from './providers-games-api.constant';

@Injectable({
  providedIn: 'root',
})
export class ProvidersGamesApiService {
  private readonly http = inject(HttpClient);

  getProviderGames(
    params: AgGridQueryParams,
    body: BaseFilterDto[],
    regionId: number,
    providerId: string,
  ): Observable<BaseResponse<BaseList<ProviderGamesDto>>> {
    return this.http.post<BaseResponse<BaseList<ProviderGamesDto>>>(searchAggregatorProviderGames(regionId, providerId), body, {
      params: {
        ...params,
      },
    });
  }
}
